import Vue from "vue";
import Vuetify from "vuetify/lib";
import en from "vuetify/src/locale/en";
import es from "vuetify/src/locale/es";

Vue.use(Vuetify);
const THEME_COLORS = {
    primary: "#e97c21",
    secondary: "#378ccc",
    romaCelesteClaro: "#00cce6", //celeste claro
    roma: "#f9d912",
    accent: "#FF6800",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107",
    cardTitle: "#3A8FCE",
    purple: "#590564",
    romaGrey: "e9e9e9",
    mute: "#e5e5e5",
    // roma colors theme
    romaPrimary: "#590564",
    // roma lesson details colors
    romaHeaderPrimary: '#040404',
    romaHeaderSecondary: '#040404',
    romaGreyCard: "#F2F2F2",
    romaGreyOne: "#AFAFAF",
    romaBlueTwo: "#70C1FF",
    incorrect: "#ff5757",
    correct: "#3a8fce",
    skipped: "#c1c1c1",
};

export default new Vuetify({
    customVariables: ['@/assets/styles/roma-theme/variables.scss'],
    theme: {
        themes: {
            light: THEME_COLORS
        }
    },
    lang: {
        locales: { en, es },
        current: "es"
    }
});
